module.exports = __webpack_public_path__ + "img/banner.b2c4a3cb.png";